<div class="main">

    <div class="frm" dir="rtl">
        <h2 style="text-align: center;">{{had}}</h2>

        <form #f="ngForm" (ngSubmit)="submit()">

            <div class="row">
                <div class="btnSave">
                    <button class="btn btn-primary" [disabled]="f.invalid || isRequesting">Save</button>
                </div>
            </div>

            <div class="row frm2" style="background-color:#f4f4f4">
                <div class="row">
                    <div class="col-lg-4 pull-right">
                        <div class="form-group">
                            <label for="stateY">State Yidish</label>
                            <input required id="stateY" name="stateY" class="form-control" [(ngModel)]="state.stateY" />
                        </div>
                        <div class="form-group" dir="ltr">
                            <label for="stateE">State English</label>
                             <input id="stateE" name="stateE" class="form-control" [(ngModel)]="state.stateE" /> 
                        </div>
                    </div>

                    <div class="col-lg-4 pull-right">
                        <div class="form-group">
                            <label for="stateMN">State Keywords</label>
                             <textarea id="stateMN" name="stateMN" cols="55" rows="5" class="form-control" [(ngModel)]="state.stateMN"></textarea> 
                        </div>
                    </div>

                </div>
                <div class="row">
                    <div class="col-lg-4 pull-right">
                        <div *ngIf="errors" class="alert alert-danger" role="alert" dir="ltr">
                            <strong>Oops!</strong> {{errors}}
                        </div>
                    </div>
                </div>
            </div>

        </form>
    </div>
</div>